import audit from './audit'

const pages = { audit }

export default pages
